import React from "react";
import { Layout } from "../components/Layout";
import { useLanguage } from "../context/LanguageContext";
import { siteContent } from "../mock/rosablu.mock";
import { Card } from "../components/ui/card";
import { AmenityIcon } from "../components/shared/AmenityIcon";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../components/ui/carousel";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { Button } from "../components/ui/button";

export default function ApartmentPage() {
  const { lang } = useLanguage();
  const suites = siteContent.suites[lang];
  const amenities = siteContent.suites.amenities;

  const images = [
    // Ingresso
    {
      src: "/images/rosablu/gallery/entrata 1.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/specchio 5.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/vetro.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/cucina1.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/cucina 16.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/cucina 9.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/cucina 13.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/divano1.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/servizi.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/servizi2.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
      // Ingresso
    {
      src: "/images/rosablu/gallery/bagno 9.webp",
      altIt: "Ingresso dell'appartamento",
      altEn: "Apartment entrance",
    },
    
    // Cucina e zona pranzo
    {
      src: "/images/rosablu/gallery/bagno 8.webp",
      altIt: "Dettaglio piano cottura e lavello",
      altEn: "Hob and sink detail",
    },
    {
      src: "/images/rosablu/gallery/bagno 6.webp",
      altIt: "Cucina e tavolo da pranzo apparecchiato",
      altEn: "Kitchen and set dining table",
    },
    {
      src: "/images/rosablu/gallery/bagno 10.webp",
      altIt: "Vista dalla cucina verso la camera",
      altEn: "View from kitchen towards bedroom",
    },
    // Camera da letto
    {
      src: "/images/rosablu/gallery/camera2.webp",
      altIt: "Camera con letto matrimoniale e singolo",
      altEn: "Bedroom with double and single bed",
    },
    {
      src: "/images/rosablu/gallery/camera3.webp",
      altIt: "Camera con letti e testata in legno",
      altEn: "Bedroom with beds and wooden headboard",
    },
    {
      src: "/images/rosablu/gallery/camera 13.webp",
      altIt: "Dettaglio letto matrimoniale con testata panoramica",
      altEn: "Double bed with panoramic headboard",
    },
    // Bagno
    {
      src: "/images/rosablu/gallery/camera 6.webp",
      altIt: "Bagno con doccia in mosaico blu",
      altEn: "Bathroom with blue mosaic shower",
    },
    {
      src: "/images/rosablu/gallery/poerta 2.webp",
      altIt: "Bagno con lavabo e finestra",
      altEn: "Bathroom with sink and window",
    },
    // Esterni
    {
      src: "/images/rosablu/gallery/porta 1.webp",
      altIt: "Esterno della casa e ingresso",
      altEn: "Exterior of the house and entrance",
    },
  ];

  const serviceGroups = {
    comfort: {
      title: lang === "it" ? "Comfort dell'alloggio" : "Lodging comforts",
      items:
        lang === "it"
          ? [
              "Camere non fumatori e struttura interamente non fumatori",
              "Riscaldamento regolabile",
              "Ingresso indipendente",
              "Vista montagna e vista giardino",
            ]
          : [
              "Non-smoking rooms and smoke-free property",
              "Adjustable heating",
              "Private entrance",
              "Mountain and garden view",
            ],
    },
    kitchen: {
      title: lang === "it" ? "Cucina attrezzata" : "Equipped kitchen",
      items:
        lang === "it"
          ? [
              "Seggiolone",
              "Macchina da caffè e bollitore elettrico",
              "Forno e forno a microonde",
              "Utensili da cucina completi",
              "Lavastoviglie e lavatrice",
            ]
          : [
              "High chair",
              "Coffee machine and electric kettle",
              "Oven and microwave",
              "Full set of kitchen utensils",
              "Dishwasher and washing machine",
            ],
    },
    bathroom: {
      title: lang === "it" ? "Bagno & media" : "Bathroom & media",
      items:
        lang === "it"
          ? [
              "Bagno privato con doccia",
              "Asciugamani e biancheria da letto",
              "Prodotti da bagno in omaggio",
              "Asciugacapelli",
              "TV con canali via cavo",
            ]
          : [
              "Private bathroom with shower",
              "Towels and bed linen",
              "Complimentary toiletries",
              "Hairdryer",
              "TV with cable channels",
            ],
    },
    activities: {
      title: lang === "it" ? "Attività" : "Activities",
      items:
        lang === "it"
          ? [
              "Sci alpino",
              "Deposito sci dedicato con spazio per l'attrezzatura",
              "Escursioni a piedi",
              "Escursioni in bicicletta",
            ]
          : [
              "Alpine skiing",
              "Dedicated ski storage for equipment",
              "Hiking",
              "Cycling excursions",
            ],
    },
    parkingWifi: {
      title: lang === "it" ? "Parcheggio & connettività" : "Parking & connectivity",
      items:
        lang === "it"
          ? [
              "Parcheggio privato gratuito in loco (non prenotabile)",
              "Connessione Wi-Fi gratuita in tutta la struttura",
              "Balcone e spazi esterni",
            ]
          : [
              "Free private parking on site (no reservation)",
              "Free Wi-Fi throughout the property",
              "Balcony and outdoor space",
            ],
    },
    safety: {
      title: lang === "it" ? "Sicurezza & lingue" : "Safety & languages",
      items:
        lang === "it"
          ? [
              "Estintori e telecamere esterne a circuito chiuso",
              "Cassaforte",
              "Possibilità di comunicare in italiano, inglese e altre lingue europee (da confermare)",
            ]
          : [
              "Fire extinguishers and external CCTV cameras",
              "Safe",
              "Possibility to communicate in Italian, English and other European languages (to be confirmed)",
            ],
    },
  };

  return (
    <Layout>
      {/* HERO appartamento */}
      {/* HERO appartamento */}
<section className="relative overflow-hidden bg-slate-900 text-slate-50">
  <div className="absolute inset-0">
    <img
      src="/images/rosablu/gallery/vetro.webp"
      alt={
        lang === "it"
          ? "Dettaglio vetrata con vista in Val di Sole"
          : "Glass detail with view in Val di Sole"
      }
      width={1600}
      height={900}
      className="h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-black/45" />
  </div>
  <div className="relative mx-auto flex max-w-5xl flex-col gap-4 px-4 pb-16 pt-16 md:px-6 md:pb-20">
    <div className="md:w-3/5">
      <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-slate-200">
        Rosa Blu Apartment
      </p>
      <h1 className="mb-3 font-serif text-3xl leading-tight md:text-4xl">
        {lang === "it" ? "L'appartamento" : "The apartment"}
      </h1>
      <p className="mb-4 max-w-xl text-sm leading-relaxed text-slate-100/90 md:text-base">
        {suites.subtitle}
      </p>
    </div>
  </div>
</section>


      {/* CAROSELLO + DESCRIZIONE */}
      <section className="bg-white pattern-apartment py-14 md:py-18">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="grid gap-8 md:grid-cols-[1.4fr,1fr] md:items-start">
            <Card className="overflow-hidden rounded-3xl border-transparent bg-[#f8f1e8] p-4 shadow-sm">
              <Carousel className="w-full">
                <CarouselContent>
                  {images.map((img, index) => (
                    <CarouselItem key={index}>
                      <div className="overflow-hidden rounded-2xl">
                        <img loading="lazy"
                          src={img.src}
                          alt={lang === "it" ? img.altIt : img.altEn}
                          className="aspect-[4/3] w-full cursor-zoom-in object-cover transition-transform duration-500 hover:scale-110"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="left-2" />
                <CarouselNext className="right-2" />
              </Carousel>
            </Card>

            <Card className="overflow-hidden rounded-3xl border-transparent bg-white/80 p-6 text-sm text-slate-800 shadow-sm backdrop-blur-sm">
              <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
                {lang === "it" ? "Gli spazi" : "Spaces"}
              </p>
              <ul className="space-y-2 text-sm leading-relaxed text-slate-700">
                {suites.perks.map((item) => (
                  <li key={item} className="flex gap-2">
                    <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-[#b07157]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Card>
          </div>
        </div>
      </section>

      {/* SERVIZI PRINCIPALI + POPUP DETTAGLIO */}
      <section className="bg-[#f8f1e8] py-14 md:py-18">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <h2 className="font-serif text-2xl text-slate-900 md:text-3xl">
            {lang === "it" ? "Servizi e comfort" : "Services & comforts"}
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-700 md:text-base">
            {lang === "it"
              ? "Una selezione di servizi pensata per rendere il soggiorno semplice, armonioso e piacevole, sia in inverno che in estate."
              : "A selection of services designed to make your stay simple, harmonious and pleasant, in both winter and summer."}
          </p>

          {/* servizi in evidenza */}
          <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {amenities.map((amenity) => (
              <Card
                key={amenity.id}
                className="flex items-start gap-3 rounded-3xl border-transparent bg-white/80 p-4 text-sm text-slate-700 shadow-sm backdrop-blur-sm"
              >
                <div className="mt-0.5 rounded-full bg-[#b07157] p-2 text-white">
                  <AmenityIcon icon={amenity.icon} />
                </div>
                <p>{amenity[lang]}</p>
              </Card>
            ))}
          </div>

          {/* macro aree con popup dettagli */}
          <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3 text-sm text-slate-800">
            {Object.entries(serviceGroups).map(([key, group]) => (
              <Card
                key={key}
                className="flex flex-col justify-between rounded-3xl border-transparent bg-white/80 p-5 shadow-sm backdrop-blur-sm"
              >
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                    {group.title}
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-slate-700">
                    {group.items[0]}
                  </p>
                </div>
                <div className="mt-4">
                  <Dialog>
                    <DialogTrigger asChild>
                      <Button
                        variant="outline"
                        className="rounded-full border-slate-400 bg-transparent px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-slate-800 hover:bg-slate-100"
                      >
                        {lang === "it" ? "Vedi tutti i dettagli" : "View all details"}
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="max-w-md rounded-3xl bg-white p-5">
                      <DialogHeader>
                        <DialogTitle className="font-serif text-lg text-slate-900">
                          {group.title}
                        </DialogTitle>
                      </DialogHeader>
                      <ul className="mt-3 space-y-1.5 text-sm leading-relaxed text-slate-700">
                        {group.items.map((item) => (
                          <li key={item} className="flex gap-2">
                            <span className="mt-[6px] h-1 w-1 rounded-full bg-[#b07157]" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </DialogContent>
                  </Dialog>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* PARTNERSHIP & CARD VANTAGGI */}
      <section className="bg-[#f8f1e8] py-14 md:py-18">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <h2 className="font-serif text-2xl text-slate-900 md:text-3xl">
            {lang === "it" ? "Partnership & Vantaggi" : "Partnership & Benefits"}
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-700 md:text-base">
            {lang === "it"
              ? "Durante il tuo soggiorno potrai usufruire di vantaggi esclusivi grazie alle nostre partnership con le card turistiche locali."
              : "During your stay you can enjoy exclusive benefits thanks to our partnerships with local tourist cards."}
          </p>

          <div className="mt-6 grid gap-6 md:grid-cols-3">
            {/* Trentino Guest Card */}
            <Card className="flex flex-col rounded-3xl border-transparent bg-white/80 p-5 text-sm text-slate-800 shadow-sm">
              <div className="mb-3 overflow-hidden rounded-2xl bg-white">
                <img loading="lazy"
                  src="/images/rosablu/cards/trentino.webp"
                  alt="Trentino Guest Card"
                  className="aspect-[16/9] w-full object-contain"
                />
              </div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                Trentino Guest Card
              </p>
              <ul className="mt-3 space-y-2 text-xs leading-relaxed text-slate-700">
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Trasporti pubblici gratuiti in tutto il Trentino" : "Free public transport throughout Trentino"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "60+ musei, 20 castelli, 40 attrazioni" : "60+ museums, 20 castles, 40 attractions"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Degustazioni prodotti tipici e sconti" : "Typical products tasting and discounts"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Terme e benessere a tariffa ridotta" : "Spa and wellness at reduced rates"}</span>
                </li>
              </ul>
            </Card>

            {/* Val di Sole Opportunity Card */}
            <Card className="flex flex-col rounded-3xl border-transparent bg-white/80 p-5 text-sm text-slate-800 shadow-sm">
              <div className="mb-3 overflow-hidden rounded-2xl bg-white">
                <img loading="lazy"
                  src="/images/rosablu/cards/valdisole.png"
                  alt="Val di Sole Opportunity Card"
                  className="aspect-[16/9] w-full object-contain"
                />
              </div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                Val di Sole Card
              </p>
              <ul className="mt-3 space-y-2 text-xs leading-relaxed text-slate-700">
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Navette scontate nel Parco Nazionale Stelvio" : "Discounted shuttles in Stelvio National Park"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Bike Train e Bike Bus in tutta la valle" : "Bike Train and Bike Bus throughout the valley"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "10% sconto noleggio bike" : "10% discount on bike rental"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "25% sconto impianti di risalita" : "25% discount on ski lifts"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "+ tutti i vantaggi Trentino Guest Card" : "+ all Trentino Guest Card benefits"}</span>
                </li>
              </ul>
            </Card>

            {/* Marilleva Ski Pass */}
            <Card className="flex flex-col rounded-3xl border-transparent bg-white/80 p-5 text-sm text-slate-800 shadow-sm">
              <div className="mb-3 overflow-hidden rounded-2xl bg-white">
                <img loading="lazy"
                  src="/images/rosablu/cards/marilleva.webp"
                  alt="Marilleva Ski Pass"
                  className="aspect-[16/9] w-full object-contain"
                />
              </div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                {lang === "it" ? "Marilleva Ski Pass" : "Marilleva Ski Pass"}
              </p>
              <ul className="mt-3 space-y-2 text-xs leading-relaxed text-slate-700">
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Richiedibile direttamente in loco" : "Available on-site"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Accesso agli impianti sciistici Marilleva" : "Access to Marilleva ski lifts"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Collegamenti con Folgarida e Madonna di Campiglio" : "Connections to Folgarida and Madonna di Campiglio"}</span>
                </li>
                <li className="flex gap-2">
                  <span className="mt-[4px] h-1 w-1 rounded-full bg-[#b07157]" />
                  <span>{lang === "it" ? "Parte del comprensorio Campiglio Dolomiti" : "Part of Campiglio Dolomiti ski area"}</span>
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
}
